export default "__VITE_ASSET__DIT5rH91__"